import { OrderIfood } from "../../../types/ordersIfood";

function differenceTwoDates(start: any, end: any) {
  const diffTime = Math.abs(end - start);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export function computeOrdersIfood(storesData: any, orders: OrderIfood[]) {
  const end = new Date();
  end.setHours(23, 59, 59, 0);
  orders.filter((o) => o.status === 'CON').forEach(order => {
    const saleDate = order.created_at.toDate();
    const differenceDate = differenceTwoDates(saleDate, end);

    console.log(differenceDate)
    if (differenceDate <= 28 && storesData[order.id_store]) {
      console.log(order.payInfo[0].fullValue);
      let effectiveTotal = Number(order.payInfo[0].fullValue * 100) || 0;
      const deliveryFeeInCents = Number(order.deliveryFee) || 0;
      effectiveTotal -= deliveryFeeInCents;

      // if (order.benefits && order.benefits.sponsor === 'MERCHANT' && order.benefits.value > 0) {
      //   const benefitInCents = Math.round(order.benefits.value * 100);
      //   effectiveTotal -= benefitInCents;
      // }

      storesData[order.id_store].data[28 - differenceDate] += effectiveTotal;
    }
  });
}